const Type = 'token';
const TokenWrapperType = 'token-wrapper';
let MatchPhase = /*#__PURE__*/function (MatchPhase) {
  MatchPhase["Deserialization"] = "deserialization";
  MatchPhase["Composition"] = "composition";
  return MatchPhase;
}({});
let Attribute = /*#__PURE__*/function (Attribute) {
  Attribute["Value"] = "value";
  Attribute["Block"] = "block";
  return Attribute;
}({});

export { Attribute, MatchPhase, TokenWrapperType, Type };
